import { AllBuyerSettings, BuyerSettings } from '../models/settings.model';

/**
 * Get the buyer settings for a given company ID.
 * @param {number} companyId - The company ID.
 * @param {AllBuyerSettings} settings - The all buyer settings.
 * @returns {BuyerSettings} - The buyer settings for the given company ID.
 */
export const getBuyerSettings = (
  settings: AllBuyerSettings,
  companyId: number,
): BuyerSettings => {
  return Object.entries(settings).reduce((result, [key, value]) => {
    result[key as keyof BuyerSettings] = value.includes(companyId);
    return result;
  }, {} as BuyerSettings);
};
